import React from "react";
import { Form, Input, Button, Rate, message } from "antd";
import styles from "../feedback.module.css";
import "../feedbackGlobal.css";

const { TextArea } = Input;

class FormFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleSubmit = this.handleSubmit.bind(this);
    this.hasErrors = this.hasErrors.bind(this);
  }

  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        message.success("Форма успешна отправлена");
        this.props.form.resetFields();
      }
      else {
        message.warning("Не все поля заполнены верно");
      }
    });
  };

  hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
  }

  validateStatusGet(name, help) {
    const { isFieldTouched, getFieldError } = this.props.form;
    const itemStatus = isFieldTouched(name) && getFieldError(name);
    let val = "";

    if (help) {
      val = itemStatus || "";
    } else {
      val = itemStatus ? "error" : "";
    }

    return val;
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    /*
    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 13 }
    };
    */

    const nameCompanyFeedbackLayout = {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 }
    };
    const emailRateLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 14 }
    };

    const tailFormItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 7 }
    };

    return (
      <div>
        <div style={{ paddingLeft: "6vw" }}>
          Свои отзывы и предложения о работе интернет-службы «Теплоинформ» Вы
          можете оставить, заполнив форму:{" "}
        </div>
        <Form
          layout="horizontal"
          onSubmit={this.handleSubmit}
          className={styles.formFeedback}
        >
          <Form.Item>
            <Form.Item
              {...nameCompanyFeedbackLayout}
              label="ФИО"
              validateStatus={this.validateStatusGet("name", false)}
              help={this.validateStatusGet("name", true)}
              style={{
                display: "inline-block",
                width: "50%",
                fontFamily: "Open Sans",
                fontSize: "0.88vw",
                marginBottom: "0px"
              }}
            >
              {getFieldDecorator("name", {
                rules: [
                  {
                    type: "string",
                    max: 250,
                    message: "Неверный формат"
                  },
                  {
                    required: true,
                    message: "Введите название организации",
                    whitespace: true
                  }
                ]
              })(<Input />)}
            </Form.Item>
            <Form.Item
              {...emailRateLayout}
              label="E-mail"
              validateStatus={this.validateStatusGet("email", false)}
              help={this.validateStatusGet("email", true)}
              style={{
                display: "inline-block",
                width: "50%",
                marginBottom: "0px"
              }}
            >
              {getFieldDecorator("email", {
                rules: [
                  {
                    type: "email",
                    message: "Некорректный формат"
                  },
                  {
                    required: true,
                    message: "Необходимо ввести E-mail"
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Form.Item>
          <Form.Item>
            <Form.Item
              {...nameCompanyFeedbackLayout}
              label="Организация"
              validateStatus={this.validateStatusGet("company", false)}
              help={this.validateStatusGet("company", true)}
              style={{
                display: "inline-block",
                width: "50%",
                marginBottom: "0px"
              }}
            >
              {getFieldDecorator("company", {
                rules: [
                  {
                    type: "string",
                    max: 250,
                    message: "Превышена максимальная длина"
                  },
                  {
                    required: false,
                    whitespace: true,
                    message: "Одни лишь пробелы недопустимы"
                  }
                ]
              })(<Input />)}
            </Form.Item>
            <Form.Item
              className={styles.scoreContainer}
              style={{
                display: "inline-block",
                width: "50%",
                paddingLeft: "2vw",
                marginBottom: "0px"
              }}
            >
              {getFieldDecorator("rate", {
                initialValue: 0
              })(<Rate style={{ color: "#fca25c" }} />)}
            </Form.Item>
          </Form.Item>

          <Form.Item
            className={styles.feddbackItem}
            {...nameCompanyFeedbackLayout}
            label="Отзыв"
            validateStatus={this.validateStatusGet("feedback", false)}
            help={this.validateStatusGet("feedback", true)}
            style={{
              display: "inline-block",
              width: "54%",
              paddingTop: "1vh"
            }}
          >
            {getFieldDecorator("feedback", {
              rules: [
                {
                  type: "string",
                  max: 2000,
                  message: "Превышена максимальная длина"
                },
                {
                  required: true,
                  whitespace: true,
                  message: "Одни лишь пробелы недопустимы"
                }
              ]
            })(
              <TextArea
                rows={1}
                style={{ minHeight: "4em", fontSize: "0.8vw" }}
              />
            )}
          </Form.Item>
          <Form.Item className={styles.buttonItem}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.hasErrors(getFieldsError())}
            >
              Отправить
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const WrappedFormFeedback = Form.create({ name: "form_feedback" })(
  FormFeedback
);

export default WrappedFormFeedback;
